import { connect } from 'react-redux';

import { Creators as userActions } from 'Reducers/user';
import { Creators as transientActions } from 'Reducers/transient';
import { Creators as adminActions } from 'Reducers/adminOnboarding';

import Dashboard from './view';

export default connect(
  state => ({
    ...state.adminOnboarding,
    ...state.transient,
    transient: state.transient,
    adminFilters: state.user.adminFilters,
    userAdminFilters: state.user.admin_filters,
    user_role: state.user.role_name,
    user: state.user
  }),
  {
    checkSendWelcomeEmail: adminActions.checkSendWelcomeEmail,
    declineProfiles: adminActions.declineProfiles,
    extendVetting: adminActions.extendVetting,
    getAdminOnboardingProfiles: adminActions.getAdminOnboardingProfiles,
    getCampaignsByClient: adminActions.getCampaignsByClient,
    getOnboardingBlocks: adminActions.getOnboardingBlocks,
    getUserOnboardingProfile: adminActions.getUserOnboardingProfile,
    reactivateProfiles: adminActions.reactivateProfiles,
    rejectVetting: adminActions.rejectVetting,
    reOnboard: adminActions.reOnboard,
    resetTransient: transientActions.reset,
    selectedProfilesForReOnboard: adminActions.selectedProfilesForReOnboard,
    sendWelcomeEmail: adminActions.sendWelcomeEmail,
    updateAdminProps: adminActions.updateProps,
    updateTransientProps: transientActions.updateProps,
    updateTransientPropWithValidations: transientActions.updatePropWithValidations,
    updateUserProps: userActions.updateProps
  }
)(Dashboard);
